import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import * as uuid from "uuid";
import { some, every, isEmpty, isEqualWith } from "lodash";
import AddressDetailsForm from "./AddressDetailsForm";
import { ADDRESS_TYPES } from "../../constants/constants";
import { getAddressDetails } from "../../util/candidateDataFilters";
import { addressObject } from "../../constants/candidateDataObjects";
import "../../styles/styles.css";
import { connect } from "react-redux";

export const AddressInfo = ({
  candidateId,
  addressDetails,
  updateCandidateAddressDetails,
  addCandidateAddressDetails,
  updateCandidateAddressDetailsBulk,
  getStatesList,
  states,
}) => {
  useEffect(() => {
    getStatesList();
  }, []);
  const currentAddress = getAddressDetails(
    ADDRESS_TYPES.CURRENT,
    addressDetails
  );

  const permanentAddress = getAddressDetails(
    ADDRESS_TYPES.PERMANENT,
    addressDetails
  );

  const handleOnChangeAddressAutoFill = e => {
    let newAddress;
    if (!e.target.checked) {
      const {
        id,
        addressType,
        candidateId,
        ...defaultAddress
      } = addressObject();

      updateCandidateAddressDetailsBulk(permanentAddress.id, {
        ...permanentAddress,
        ...defaultAddress,
      });
      return;
    }
    if (!isEmpty(permanentAddress) && permanentAddress.id) {
      const { id, addressType, ...addressToUpdate } = currentAddress;
      newAddress = { ...permanentAddress, ...addressToUpdate };

      updateCandidateAddressDetailsBulk(permanentAddress.id, newAddress);
    } else {
      newAddress = {
        ...currentAddress,
        id: `temp_${uuid.v4()}`,
        candidateId,
        addressType: ADDRESS_TYPES.PERMANENT,
      };
      addCandidateAddressDetails(newAddress);
    }
  };

  const isDisabledAddressAutoFill = () => {
    const { id, addressType, candidateId, ...address } = currentAddress;
    return isEmpty(address) || (!isEmpty(address) && every(address, isEmpty));
  };

  const isCheckedAddressAutoFill = () => {
    const { id, addressType, ...currentAddressData } = currentAddress;
    const {
      id: permanentAddressId,
      addressType: permanentAddressType,
      ...permanentAdressData
    } = permanentAddress;

    return (
      !isEmpty(currentAddressData) &&
      isEqualWith(
        currentAddressData,
        permanentAdressData,
        (currentAddressVal, permanentAddressVal) => {
          if (currentAddressVal == permanentAddressVal) return true;
        }
      )
    );
  };
  return (
    <div className="container w-100 h-100 mx-auto pt-3 mb-5 org-details">
      <AddressDetailsForm
        candidateId={candidateId}
        addressDetails={currentAddress}
        addressType={ADDRESS_TYPES.CURRENT}
        updateCandidateAddressDetails={updateCandidateAddressDetails}
        addCandidateAddressDetails={addCandidateAddressDetails}
        states={states}
      />
      <Form.Check
        className="address-autofill-checkbox"
        label="Permanent Address Same as Current Address"
        disabled={isDisabledAddressAutoFill()}
        onChange={handleOnChangeAddressAutoFill}
        checked={isCheckedAddressAutoFill()}
      />
      <AddressDetailsForm
        candidateId={candidateId}
        addressDetails={permanentAddress}
        addressType={ADDRESS_TYPES.PERMANENT}
        updateCandidateAddressDetails={updateCandidateAddressDetails}
        addCandidateAddressDetails={addCandidateAddressDetails}
        states={states}
      />
    </div>
  );
};
export default AddressInfo;
